class ConversionSearch {
    isOpenAttrbute = 'is-open';

    constructor(buttonEl, barEl) {
        this.buttonEl = buttonEl;
        this.barEl = barEl;
        this.isOpen = false;

        if (!this.buttonEl || !this.barEl) return;

        this._init();
    }

    _init() {
        this.buttonEl.addEventListener('click', this._handleButtonClick.bind(this));

        window.addEventListener('topbar-search-open', this._close.bind(this));
    }

    _handleButtonClick() {
        this.isOpen ? this._close() : this._open();
    }

    _close() {
        this.isOpen = false;
        this._updateUI();

        window.removeEventListener('click', this._handleWindowClick);
    }

    _open() {
        this.isOpen = true;
        this._updateUI();

        this.barEl.dispatchEvent(new CustomEvent('conversion-search-bar-open', {
            bubbles: true,
            composed: true
        }))

        requestAnimationFrame(() => {
            window.addEventListener('click', this._handleWindowClick.bind(this), { once: true });
        });
    }

    _updateUI() {
        this.isOpen
            ? this.barEl.setAttribute(this.isOpenAttrbute, '')
            : this.barEl.removeAttribute(this.isOpenAttrbute);
    }

    _handleWindowClick(event) {
        if (!event.target.closest('.conversion-search-bar')) this._close();
    }
}

export function initConversionSearch() {
    const conversionSearchButton = document.querySelector('.conversion-search-button');
    const conversionSearchBar = document.querySelector('.conversion-search-bar');

    if (!conversionSearchButton || !conversionSearchBar) return;

    new ConversionSearch(conversionSearchButton, conversionSearchBar);
}
